/** @jsxImportSource @emotion/react */

'use client';

import { Box } from '@mui/material';
import type { ReactNode } from 'react';

import { useLayoutContext } from '@campaign-manager/feature/context/LayoutContext';

import * as styles from './styles';

export const content = {
  description: null,
  illustrationUrl: '/illustration-placeholder.svg',
};

export default function Page({ children }: { children: ReactNode }) {
  const { project } = useLayoutContext();

  const contentIllustrationUrl = project?.landing_page?.illustration_url
    ? project.landing_page.illustration_url
    : content.illustrationUrl;

  const backgroundColor = project?.landing_page?.background_color
    ? `${project.landing_page.background_color}!important`
    : undefined;

  return (
    <Box css={styles.formPage}>
      <Box
        css={styles.graphicsSide}
        sx={{ backgroundColor }}
        suppressHydrationWarning
      >
        <img
          src={contentIllustrationUrl}
          style={{ maxWidth: 500 }}
        />
      </Box>
      <Box css={styles.formSide}>{children}</Box>
    </Box>
  );
}
